import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    type CredentialRotationManualPromotionRequest,
    type CredentialRotationManualPromotionResponse,
} from '@pillar-portal/api-types';
import { ipxCredentialManagementApi } from '@/lib/pillarApi';
import { buildRoleScopedQueryKey } from '@/lib/reactQueryRoleScope';
import { useAuthStore } from '@/store/auth';

export function useManualCredentialPromotion() {
    const queryClient = useQueryClient();
    const activeRoleAssignmentId: number | null = useAuthStore(
        (state) => state.activeRoleAssignmentId
    );
    return useMutation<
        CredentialRotationManualPromotionResponse,
        Error,
        CredentialRotationManualPromotionRequest
    >({
        mutationFn: async (request) =>
            await ipxCredentialManagementApi.manualPromoteCredentialRotationAttempt(request),
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: buildRoleScopedQueryKey(activeRoleAssignmentId, [
                        'credential-rotation-history',
                    ]),
                }),
                queryClient.invalidateQueries({
                    queryKey: buildRoleScopedQueryKey(activeRoleAssignmentId, [
                        'ipx-credential-policy-detail',
                    ]),
                }),
                queryClient.invalidateQueries({
                    queryKey: buildRoleScopedQueryKey(activeRoleAssignmentId, [
                        'dashboard',
                        'website-credentials',
                    ]),
                }),
                queryClient.invalidateQueries({
                    queryKey: buildRoleScopedQueryKey(activeRoleAssignmentId, [
                        'ipx-credential-policies',
                    ]),
                }),
            ]);
        },
    });
}
